import { createReducer } from 'src/helpers/reducer';
import actions from './actions';

const initState = {
  isSearchLoading: false,
  results: null,
  isRecentLoading: false,
  isClickItemLoading: false,
  recent: null,
  resultsTotalCount: 0,
};

function onClickItemRequest(state) {
  return {
    ...state,
    isClickItemLoading: true,
  };
}

function onClickItemSuccess(state) {
  return {
    ...state,
    isClickItemLoading: false,
  };
}

function onClickItemError(state) {
  return {
    ...state,
    isClickItemLoading: false,
  };
}

function onGetRecentRequest(state) {
  return {
    ...state,
    isRecentLoading: true,
  };
}

function onGetRecentSuccess(state, { payload }) {
  const { records } = payload;

  return {
    ...state,
    isRecentLoading: false,
    recent: records,
  };
}

function onGetRecentError(state) {
  return {
    ...state,
    isRecentLoading: false,
  };
}

function onSearchRequest(state, { payload }) {
  const { page } = payload;

  return {
    ...state,
    isSearchLoading: page === 1,
    isLoadMoreLoading: page !== 1,
  };
}

function onSearchSuccess(state, { payload }) {
  const { records, page, total_count } = payload;

  return {
    ...state,
    isSearchLoading: false,
    results: page === 1 ? records : [...(state.results || []), ...records],
    isLoadMoreLoading: false,
    resultsTotalCount: total_count,
  };
}

function onSearchError(state) {
  return {
    ...state,
    isSearchLoading: false,
    isLoadMoreLoading: false,
  };
}

function onClearStore(state) {
  return {
    ...initState,
    recent: state?.recent,
  };
}

export default createReducer(initState, {
  [actions.SEARCH_REQUEST]: onSearchRequest,
  [actions.SEARCH_SUCCESS]: onSearchSuccess,
  [actions.SEARCH_ERROR]: onSearchError,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.GET_RECENT_REQUEST]: onGetRecentRequest,
  [actions.GET_RECENT_SUCCESS]: onGetRecentSuccess,
  [actions.GET_RECENT_ERROR]: onGetRecentError,
  [actions.CLICK_ITEM_REQUEST]: onClickItemRequest,
  [actions.CLICK_ITEM_SUCCESS]: onClickItemSuccess,
  [actions.CLICK_ITEM_ERROR]: onClickItemError,
});
